import { ISRPSearchParams } from 'contexts/FilterSearchContext'
import { SessionStorageKey } from 'common/constants'
import produce from 'immer'
import { createContext, PropsWithChildren, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { ISortBy } from 'types/baseTypes'
import { getDefaultSRPFilter, resetSRPFilter } from 'utils/menuUtils'
import { parseUrlSearchParams } from 'utils/urlParams'

export interface IVehicleListState {
  currentPage: number
  totalPages?: number
  currentSortBy: ISortBy
  currentPageSize: number
  selectedVehicles: number[]
}

type SetStateAction<T> = (state: T) => void

export interface IVehicleListContext extends IVehicleListState {
  setVehiclesState: (action: SetStateAction<IVehicleListState>) => void
}

export const VehicleListContext = createContext<IVehicleListContext>(null)

export const VehicleListContextProvider = ({ children }: PropsWithChildren<{}>) => {
  const location = useLocation()

  useMemo(() => {
    const query = parseUrlSearchParams<ISRPSearchParams>(location.search)
    if (query?.clearSearch) {
      resetSRPFilter()
    }
  }, [location.search])

  const [state, setState] = useState<IVehicleListState>(() => {
    const defaultFilter = getDefaultSRPFilter(location.pathname)
    return {
      ...defaultFilter,
      selectedVehicles: []
    }
  })

  useEffect(() => {
    sessionStorage.setItem(SessionStorageKey.PAGE_PATHNAME, location.pathname)
  }, [location.pathname])

  useEffect(() => {
    sessionStorage.setItem(SessionStorageKey.PAGE_SELECTED, state.currentPage.toString())
    sessionStorage.setItem(SessionStorageKey.PAGE_SIZE, state.currentPageSize.toString())
    sessionStorage.setItem(SessionStorageKey.SESSION_SORT, JSON.stringify(state.currentSortBy))
  }, [state.currentPage, state.currentPageSize, state.currentSortBy])

  const setVehiclesState = (action: SetStateAction<IVehicleListState>) => {
    setState(produce(state, action))
  }
  return <VehicleListContext.Provider value={{ ...state, setVehiclesState }}>{children}</VehicleListContext.Provider>
}
